import PermissionsPage from '@/views/profile/PermissionsPage'

export default function PermissionsScreen() {
  return <PermissionsPage />
}
